import React from "react";
import { Link } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";

import { APP_URL } from "../../config";

import { PopoutDrawer, useDrawerInit } from "../../components/Navbar";

interface Props {
  showReferral?: boolean;
}

export default function PublicNavBar({ showReferral = false }: Props) {
  const { isAdminUser, isLoggedIn, isOpen, onClose, onLogout, onOpen, ref } =
    useDrawerInit();

  return (
    <ChakraProvider resetCSS={false}>
      <PopoutDrawer
        ref={ref}
        {...{ isAdminUser, isLoggedIn, isOpen, onClose, onLogout, onOpen }}
      />
      <div className="navbar-container sticky-top bg-white">
        <div className="container">
          <div
            data-collapse="medium"
            data-animation="default"
            data-duration={400}
            role="banner"
            className="navbar w-nav"
          >
            <Link to="/" className="w-nav-brand">
              <img
                src="/assets/images/landing-page/byblack_logo2x.png"
                width={130}
                srcSet="/assets/images/landing-page/byblack_logo2x-p-500.png 500w, /assets/images/landing-page/byblack_logo2x-p-800.png 800w, /assets/images/landing-page/byblack_logo2x-p-1080.png 1080w, /assets/images/landing-page/byblack_logo2x.png 1195w"
                sizes="130px"
                alt=""
              />
            </Link>
            <div className="navbar-content">
              {showReferral && (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginRight: "2em" }}
                  href={`https://byblack.us/refer-a-business?referrer=${APP_URL}`}
                >
                  Refer Companies to ByBlack
                </a>
              )}
              <Link to="/review" className="button navbar-button w-button">
                Go to Dashboard
              </Link>
              <button
                className="navbar-toggle-button w-nav-button"
                onClick={onOpen}
                ref={ref}
              >
                <img
                  src="/assets/images/landing-page/icon-menu.svg"
                  alt=""
                  className="navbar-toggle-icon"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </ChakraProvider>
  );
}
